import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { LOG_INVENTORY_ISSUE_ORDER } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// 🔁 Lazy-loaded components
const LogInventoryList = lazy(() => import("app/pages/Inventory/LogInventory/ListLog"));
const AddLogStock = lazy(() => import("app/pages/Inventory/LogInventory/AddLog"));
const EditLogStock = lazy(() => import("app/pages/Inventory/LogInventory/EditLog"));
const ViewDetails = lazy(() => import("app/pages/Inventory/LogInventory/ListLog/Approval/ViewDetails"));
const LogIssueOrder = lazy(() => import("app/pages/Inventory/LogInventory/LogIssueOrder"));

// ✅ Route definition
export const logInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "log_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/log",
        element: LoadablePage(LogInventoryList),
      },
      {
        path: "/inventory/log/add",
        element: LoadablePage(AddLogStock),
      },
      {
        path: "/inventory/log/edit",
        element: LoadablePage(EditLogStock),
      },
      {
        path: "/inventory/log-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: LOG_INVENTORY_ISSUE_ORDER,
        element: LoadablePage(LogIssueOrder),
      },
    ],
  },
];
